import type * as React from 'react';
import { get } from '@Domain/Api';
import auditEntriesFetched, {
	type AuditEntriesFetchedAction,
	type AuditEntriesFetchedPayload,
} from '@Application/AuditTrail/Actions/auditEntriesFetched';
import auditEntriesFetchFailed, {
	type AuditEntriesFetchFailedAction,
} from '@Application/AuditTrail/Actions/auditEntriesFetchFailed';
import type FetchAuditEntries from '@Application/AuditTrail/Queries/FetchAuditEntries';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../parameters';

type Actions = AuditEntriesFetchedAction | AuditEntriesFetchFailedAction;

export default (query: FetchAuditEntries) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			// Server-side pagination: `get` is used deliberately, never `getPaginated` (which walks every
			// page and would make `totalRecords` lie to the paginator).
			const baseUrl = `${parameters.api.host}/api/accounts/${query.accountId}/audit-entries`;
			const queryString = query.toQueryString();
			const url = queryString.length > 0 ? `${baseUrl}?${queryString}` : baseUrl;

			const payload = await get<AuditEntriesFetchedPayload>(url);

			const action = auditEntriesFetched(payload, query.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = auditEntriesFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
